export default function imageToBase64(imageFile) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        // When the file is read as DataURL (Base64 encoded string)
        reader.onloadend = () => {
            resolve(reader.result); // reader.result contains the Base64 string
        };
        
        // In case of an error
        reader.onerror = reject;
        
        // Start reading the file as a DataURL
        reader.readAsDataURL(imageFile);
    });
}

